import { REFERRER_COOKIE_PREFIX } from '@sleepstation/const'
import {
  daysInSeconds,
  extractQueryStringToObj,
  pickReferrerCookies,
} from '@sleepstation/utils'
import { assoc, find, forEach, mapObjIndexed, pick, propEq } from 'ramda'
import { isNotNil } from 'ramda-adjunct'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getCookieKey = (name) => `${REFERRER_COOKIE_PREFIX}_${name}`

const setCookiesWithPrefix = (cookies, domain, filteredParams) =>
  mapObjIndexed((value, name) => {
    cookies.set(getCookieKey(name), value, {
      domain,
      path: `/`,
      secure: true,
      maxAge: daysInSeconds(90),
    })
  }, filteredParams)

const deleteCookiesWithPrefix = (cookies, domain, keys) =>
  forEach((name) => {
    cookies.remove(getCookieKey(name), {
      domain,
      path: `/`,
      secure: true,
    })
  }, keys)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const writeReferrerKeysToCookies = (cookies, domain, params) => {
  setCookiesWithPrefix(cookies, domain, params)
}

const modifyParams = ({ utm }, params, cookies, domain, keys) => {
  if (utm.ensure) {
    const {
      ensure: { tag, name, isExclusive },
    } = utm

    const storedKeys = pickReferrerCookies(cookies.cookies)
    // If tag isn't passed in via the query string and isn't already stored,
    // default to the tag
    if (params[tag] === name || storedKeys[tag] !== name) {
      // If exclusive, delete any existing utm values
      if (isExclusive) {
        deleteCookiesWithPrefix(cookies, domain, keys)
      }

      // Add the specified tag
      return assoc(tag, name, params)
    }
  }
  return params
}

export const processReferrerKeys = (
  keys,
  queryString,
  domain,
  cookies,
  tracking
) => {
  const params = extractQueryStringToObj(queryString)
  const filteredParams = pick(keys, params)
  const resolvedParams = isNotNil(tracking)
    ? modifyParams(tracking, filteredParams, cookies, domain, keys)
    : filteredParams
  writeReferrerKeysToCookies(cookies, domain, resolvedParams)
}

export const getVersionedCookieName = (name, version) => `${name}-${version}`

export const findCookieById = (id, cookies) => find(propEq(id, `id`), cookies)
